import formatAmount from './format-amount.js';
import { isNumber } from './string-num-clean.js';

function formatDefaultDepositAmounts(
	defaultDepositAmounts,
	currency
	// selected = 'PARAM_AMOUNT1'
) {
	/*
		parse the format of
	{PARAM_AMOUNT1: 35, PARAM_AMOUNT2: 70 ..., PARAM_AMOUNT_NUM: valN, currency:'kr'}
	to {PARAM_AMOUNT1:{value:35,text:'35 kr',selected:true|false}, {...}, {...},{...}}
	*/
	const formatted = {};
	Object.keys(defaultDepositAmounts).forEach(key => {
		if (key === 'PARAM_AMOUNT1' || key === 'PARAM_AMOUNT2' || key === 'PARAM_AMOUNT3' || key === 'PARAM_AMOUNT4') {
			formatted[key] = {
				text: formatAmount(defaultDepositAmounts[key].toString(), currency),
				// selected: selected === key,
				value: isNumber(defaultDepositAmounts[key]) ? defaultDepositAmounts[key] : ''
			};
		}
	});

	return formatted;
}

export default formatDefaultDepositAmounts;
